import LegacyApiService from "./LegacyApiService";

class DayOffsService {
  getAll() {
    return LegacyApiService.get("/day-offs");
  }
}

export default new DayOffsService();
